import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  Input,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { CoreStorageEnum } from 'src/app/models/core-storage.enum';
import { TranslatePipe } from '@ngx-translate/core';
import { TEMPLATES_KEYS } from 'src/app/services/application-resources/templates.service';

@Component({
    selector: 'app-info-form',
    templateUrl: './info-form.component.html',
    providers: [TranslatePipe],
    standalone: false
})
export class InfoFormComponent implements OnInit, AfterViewInit {
    @Output() formSubmit: EventEmitter<string> = new EventEmitter<string>();
    @Input() submitting: boolean;
    @Input() title: string = 'BO_NOTE';
    @Input() templatesKey: string = TEMPLATES_KEYS.DEFAULT;
    @Output() public cancel: EventEmitter<any> = new EventEmitter<any>();
    @ViewChild('text', { read: ElementRef }) public text: ElementRef;

  public infoForm: UntypedFormGroup;

  constructor(private fb: UntypedFormBuilder, private translatePipe: TranslatePipe) {}

  public ngOnInit(): void {
    this.infoForm = this.fb.group({
      message: [''],
    });
  }

  public ngAfterViewInit(): void {
    this.text.nativeElement.focus();
  }

  public onSubmit() {
    this.formSubmit.emit(this.text.nativeElement.value);
  }

  public goToBack(): void {
    this.cancel.emit();
  }

  templateSelected(templateText: string) {
    this.infoForm.get('message').setValue(templateText);
  }

  public showTemplates(): boolean {
    var clientId = localStorage.getItem(CoreStorageEnum.clientId);
    if (clientId === '91319') return true;
    return false;
    }
}
